const PauseCircled = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 4.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15M3.5 12a8.5 8.5 0 1 1 17 0 8.5 8.5 0 0 1-17 0"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M10.665 14.856a.48.48 0 0 1-.357.144.48.48 0 0 1-.356-.144c-.096-.096-.144-.714-.144-.356v-5q0-.212.143-.356A.48.48 0 0 1 10.307 9q.212 0 .357.144a.48.48 0 0 1 .144.356v5c0-.358-.048.26-.143.356M14.049 14.856a.48.48 0 0 1-.356.144.49.49 0 0 1-.357-.144c-.096-.096-.144-.714-.144-.356v-5q0-.212.143-.356A.48.48 0 0 1 13.692 9q.212 0 .356.144a.48.48 0 0 1 .144.356v5c0-.358-.047.26-.143.356"
    />
  </>
)
export default PauseCircled
